import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../layout/Modal';
import AchievementsPopup from './AchievementsPopup';

/**
 * Modal osiągnięć z filtrem w nagłówku (stan musi być obok Modal).
 */
function AchievementsModal({ popup, onClose }) {
  const [onlyOwned, setOnlyOwned] = useState(false);
  const { t } = useTranslation(['profile']);
  const onlyOwnedLabel = t('achievementsPopup.onlyOwned');

  return (
    <Modal
      isOpen={popup.isOpen}
      onClose={onClose}
      title={t('achievementsPopup.title')}
      headerEnd={
        <label className="modal-header-inline-control">
          <input
            type="checkbox"
            checked={onlyOwned}
            onChange={(e) => setOnlyOwned(e.target.checked)}
            aria-label={onlyOwnedLabel}
          />
          <span>{onlyOwnedLabel}</span>
        </label>
      }
      priority={popup.priority}
      className="modal-content-achievements"
    >
      <AchievementsPopup
        userRole={popup.data?.userRole}
        stats={popup.data?.stats}
        onlyOwned={onlyOwned}
      />
    </Modal>
  );
}

export default AchievementsModal;
